import { environment } from './../../environments/environment';

import { Injectable, Injector, NgZone } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private auth: AuthService,private router: Router,private injector: Injector) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {


            if (err.status === 401) {

              console.error(err)
                // auto logout if 401 response returned from api
                this.auth.logout();
                // this.router.navigate(['login']);

                let base=environment.angularServer;
                let loginPage='login-page';

                window.location.replace(base+loginPage);
                 //Test a fix for the stocking issue
                // const routerService = this.injector.get(Router);
                // const ngZone = this.injector.get(NgZone);
                // ngZone.run(() => {
                //   routerService.navigateByUrl('login-page');
                // });
                //location.reload(true);
            }


            return throwError(err);
            //const error = err.error.message || err.statusText;
            //return throwError(error);
        }))
    }
}
